import React from 'react';
import { Key } from 'w3c-keys';
import { Vertical } from '../../../../../layout';
import { Link } from '../../../../../link/link';
import { Typography } from '../../../../../typography';
import styles from '../primary-column.module.scss';
export const PrimaryExtendedContentComponent = ({ primaryUrl, primaryText, primaryTextOnClick, secondaryText, }) => {
    const onRowNameClicked = (e) => {
        if (e.metaKey || e.ctrlKey) {
            // eslint-disable-next-line security/detect-non-literal-fs-filename
            window.open(primaryUrl, '_blank', 'noopener');
        }
        else {
            primaryTextOnClick();
        }
        e.preventDefault();
    };
    const onRowNameSelected = (e) => {
        if (e.key === Key.Enter) {
            onRowNameClicked(e);
        }
    };
    return (React.createElement(Vertical, { className: styles.extendedContent },
        React.createElement(Typography, { variant: "content-label-subhead", "data-testid": "primary-extended-content-testid", className: styles.primaryText, noMargin: true },
            React.createElement(Link, { className: styles.title, href: primaryUrl, onClick: onRowNameClicked, onKeyPress: onRowNameSelected }, primaryText)),
        secondaryText !== '' && (React.createElement(Typography, { variant: "footnote", "data-testid": "primary-column-description-testid", className: styles.secondaryText, noMargin: true }, secondaryText))));
};
//# sourceMappingURL=primary-extended-content.component.js.map